import angular from 'angular';
import component from './escalation-builder.component';
import contactGroupWarnings from '../alert-templates/template-detail/contact-group-warnings';

const escalationBuilderModule = angular
    .module('dt.components.organization-alert-config.escalation-builder', [
        contactGroupWarnings
    ])
    .component('escalationBuilder', component);

export default escalationBuilderModule.name;
